import script from "./ClockComponent.vue?vue&type=script&lang=tsx&setup=true"
export * from "./ClockComponent.vue?vue&type=script&lang=tsx&setup=true"

import "./ClockComponent.vue?vue&type=style&index=0&id=ebc6ac58&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ebc6ac58"]])

export default __exports__